// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1__jD","cls2":"AccountMenu-cls2_nIt AccountMenu-cls1__jD"};